import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectedMovie, removeSelectedMovie } from '../redux/actions/movieActions';
import MovieDetailComponent from '../components/MovieDetailComponent/MovieDetailComponent'

const MovieDetail = () => {
    const movieDetails = useSelector((state) => state.movie);
    const {movieId} = useParams();
    const dispatch = useDispatch();
    const [videoKey, setVideoKey] = useState("")

    const getMovieDetails = async () => {
        const url = (`https://api.themoviedb.org/3/movie/${movieId}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`);
        const movieResponse = await fetch(url);
        const detailsData = await movieResponse.json();
        dispatch(selectedMovie(detailsData))
        
        const url2 = (`https://api.themoviedb.org/3/movie/${movieId}/videos?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`)
        const videoResponse = await fetch(url2);
        const videoData = await videoResponse.json()
        setVideoKey(videoData.results[0].key)
    }

    useEffect(() => {
        if(movieId && movieId !== "") getMovieDetails();
        return () => {
            dispatch(removeSelectedMovie());
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [movieId])

    return (
        <div>
            <MovieDetailComponent movieDet={movieDetails} videoKey={videoKey} />
        </div>
    )
}

export default MovieDetail
